import React, { useState, useEffect } from "react";
import Wrapper from "../../UI/Wrapper";
import "../RevenueData/RevenueData.css";
import axios from "axios";
import { DateRangePicker } from "react-date-range";

const RevenueData = () => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [usersLeadCount, setUsersLeadCount] = useState([]);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc"); // Default sort order is ascending
  const [totalSales, setTotalSales] = useState(0);
  const [totalCogs, setTotalCogs] = useState(0);
  const [totalGPYearly, setTotalGPYearly] = useState(0);
  const [totalGPRatio, setTotalGPRatio] = useState(0);
  const [totalJobs, setTotalJobs] = useState(0);
  const [totalGPShipment, setTotalGPShipment] = useState(0);
  const [totalSalesShipment, setTotalSalesShipment] = useState(0);
  const [isUserLeadDataOpen, setIsUserLeadDataOpen] = useState(false);
  const [dateRangeUser, setDateRangeUser] = useState("Custom Dates");
  const [filterRegionData, setFilterRegionData] = useState(0);
  const [filterCityData, setFilterCityData] = useState(0);

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetDashboardRevenueServicesData?startDate=&endDate=&region=&city=`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            if (response.data.data != null) {
              setUsersLeadCount(response.data.data);
              setTotalSales(response.data.TotalSales);
              setTotalCogs(response.data.TotalCogs);
              setTotalGPYearly(response.data.TotalGPYearly);
              setTotalGPRatio(response.data.TotalGPRatio);
              setTotalJobs(response.data.total_jobs);
              setTotalGPShipment(response.data.total_gp_shipment);
              setTotalSalesShipment(response.data.TotalSalesShipment);
              //   setInitialLeadData(response.data.data[0]);
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const getConversionColor = (percentage) => {
    if (percentage < 50) return "red";
    return "green";
  };

  const sortAndToggleOrder = (column) => {
    // Determine the new sort order
    const newSortOrder =
      sortedColumn !== column || sortOrder === "desc" ? "asc" : "desc";

    let sortedData = [...usersLeadCount];
    // Sorting logic here (adjusted to use newSortOrder)
    if (column === "sales") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "cogs") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "gp_yearly") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "gp_ratio") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "no_of_jobs") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "avg_gp_shipment") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    } else if (column === "avg_sale_shipment") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    }

    // setUsersLeadCount(sortedData);
    setSortedColumn(column);
    setSortOrder(newSortOrder);
  };

  const toggleLeadCountUser = () => {
    setIsUserLeadDataOpen(!isUserLeadDataOpen);
    // if (isLeadStagePickerOpen || isLeadSourcePickerOpen) {
    //   setLeadStagePickerOpen(false);
    //   setLeadSourcePickerOpen(false);
    // }
  };

  const [selectionRangeUser, setSelectionRangeUser] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const handleSelectleadUser = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setSelectionRangeUser({
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    });
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  const closeButtonLeadCountUser = () => {
    setIsUserLeadDataOpen(!isUserLeadDataOpen);
  };

  const handleFilterUserChange = (event) => {
    setFilterRegionData(event.target.value);
  };

  const userLeadApplyButton = () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    let cdate = formatDate(new Date());
    let startdate = selectionRangeUser.startDate
      ? formatDate(selectionRangeUser.startDate)
      : "";
    let enddate = selectionRangeUser.endDate
      ? formatDate(selectionRangeUser.endDate)
      : "";

    if (startdate === cdate && enddate === cdate) {
      setDateRangeUser("Select Date Range");
      startdate = "";
      enddate = "";
    } else {
      setDateRangeUser(startdate + " - " + enddate);
    }

    setIsUserLeadDataOpen(false);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetDashboardRevenueServicesData?startDate=${startdate}&endDate=${enddate}&region=${filterRegionData}&city=${filterCityData}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response && response.data && response.data.data) {
            setUsersLeadCount(response.data.data);
            setTotalSales(response.data.TotalSales);
            setTotalCogs(response.data.TotalCogs);
            setTotalGPYearly(response.data.TotalGPYearly);
            setTotalGPRatio(response.data.TotalGPRatio);
            setTotalJobs(response.data.total_jobs);
            setTotalGPShipment(response.data.total_gp_shipment);
            setTotalSalesShipment(response.data.TotalSalesShipment);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  return (
    <>
      <div className="row" style={{ marginLeft: "6px" }}>
        <Wrapper className="pettyCashWrapper">
          <div className="col-12" style={{ paddingBottom: "13px" }}>
            <div className="outerFilterLeadUser">
              <div
                style={{
                  display: "flex",
                  border: "1px solid #C0C6CC",
                  borderRadius: "16px",
                  marginTop: "11px",
                  marginLeft: "17px",
                  padding: "7px 8px 0px 13px",
                  height: "55px",
                }}
              >
                <div className="filter-icon-stage-user">
                  <img
                    src={require("../../../Icons/filterIcon.png")}
                    alt="filter"
                  />
                  FILTER
                </div>

                <div style={{ paddingRight: "6px" }}>
                  <button
                    style={{
                      marginBottom: "1rem",
                      width: "10rem",
                      height: "2.5rem",
                      borderRadius: "0.5rem",
                      fontSize: "11px",
                    }}
                    onClick={toggleLeadCountUser}
                  >
                    {" "}
                    <b> {dateRangeUser}</b>
                  </button>
                  {isUserLeadDataOpen && (
                    <div
                      style={{
                        position: "absolute",
                        zIndex: 999,
                        border: "solid 1px black",
                        marginLeft: "-5pc",
                        width: "35pc",
                        background: "white",
                      }}
                    >
                      <DateRangePicker
                        ranges={[selectionRangeUser]}
                        onChange={handleSelectleadUser}
                      />
                      <button
                        onClick={userLeadApplyButton}
                        style={{
                          marginBottom: "1rem",
                          width: "8rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          position: "relative",
                          top: "1px",
                          left: "16pc",
                          backgroundColor: "#5B489D",
                          color: "White",
                          border: "none",
                        }}
                      >
                        Apply Filter
                      </button>
                      <button
                        onClick={closeButtonLeadCountUser}
                        style={{
                          marginBottom: "1rem",
                          width: "7.5rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          position: "relative",
                          top: "1px",
                          left: "17pc",
                          color: "red",
                          backgroundColor: "white",
                          border: "none",
                          fontWeight: "bold",
                        }}
                      >
                        Close
                      </button>
                    </div>
                  )}
                </div>
                <div style={{ paddingRight: "6px" }}>
                  <select
                    style={{
                      marginBottom: "1rem",
                      width: "6rem",
                      height: "2.5rem",
                      borderRadius: "0.5rem",
                      fontSize: "13px",
                      fontWeight: "bold",
                    }}
                    name="filterRegionData"
                    value={filterRegionData}
                    onChange={handleFilterUserChange}
                  >
                    <option value=""> Region</option>
                    <option value="1">North</option>
                    <option value="2">East</option>
                    <option value="3">West</option>
                    <option value="4">South</option>
                  </select>
                </div>
                <div style={{ paddingRight: "6px" }}>
                  <select
                    style={{
                      marginBottom: "1rem",
                      width: "6rem",
                      height: "2.5rem",
                      borderRadius: "0.5rem",
                      fontSize: "13px",
                      fontWeight: "bold",
                    }}
                    // name="filterRegionData"
                    // value={filterRegionData}
                    // onChange={handleFilterUserChange}
                  >
                    <option value=""> City</option>
                  </select>
                </div>
                <div>
                  <button
                    style={{
                      width: "5rem",
                      height: "2.5rem",
                      borderRadius: "0.5rem",
                      fontSize: "12px",
                      backgroundColor: "#5B489D",
                      color: "white",
                      fontWeight: "bold",
                    }}
                    onClick={userLeadApplyButton}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>

            <hr style={{ background: "red" }} />

            <p
              style={{ color: "#6A6A6A", fontSize: "18px", fontWeight: "700" }}
            >
              Revenue By Services
            </p>
            <div>
              <table className="revenueServicesColumns">
                <thead>
                  <tr>
                    <th>Service Type</th>
                    <th onClick={() => sortAndToggleOrder("sales")}>
                      Sales{" "}
                      {sortedColumn === "sales" && (
                        <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                      )}
                    </th>
                    <th onClick={() => sortAndToggleOrder("cogs")}>
                      COGS{" "}
                      {sortedColumn === "cogs" && (
                        <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                      )}
                    </th>
                    <th onClick={() => sortAndToggleOrder("gp_yearly")}>
                      G.P. Yearly{" "}
                      {sortedColumn === "gp_yearly" && (
                        <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                      )}
                    </th>
                    <th onClick={() => sortAndToggleOrder("gp_ratio")}>
                      G.P. Ratio (%){" "}
                      {sortedColumn === "gp_ratio" && (
                        <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                      )}
                    </th>
                    <th onClick={() => sortAndToggleOrder("no_of_jobs")}>
                      No. of Jobs{" "}
                      {sortedColumn === "no_of_jobs" && (
                        <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                      )}
                    </th>
                    <th onClick={() => sortAndToggleOrder("avg_gp_shipment")}>
                      Average G.P./ Shipment{" "}
                      {sortedColumn === "avg_gp_shipment" && (
                        <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                      )}
                    </th>
                    <th onClick={() => sortAndToggleOrder("avg_sale_shipment")}>
                      Average Sale/ Shipment{" "}
                      {sortedColumn === "avg_sale_shipment" && (
                        <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {usersLeadCount.map((user, index) => (
                    <tr key={index}>
                      <td>{user.service_type}</td>
                      <td>{user.sales}</td>
                      <td>{user.cogs}</td>
                      <td>{user.gp_yearly}</td>
                      <td>
                        <div
                          style={{
                            width: "92px",
                            height: "35px",
                            borderRadius: "29px",
                            backgroundColor: getConversionColor(user.gp_ratio),
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginLeft: "20%",
                          }}
                        >
                          {user.gp_ratio} %
                        </div>
                      </td>
                      <td>{user.no_of_jobs}</td>
                      <td>{user.avg_gp_shipment}</td>
                      <td>{user.avg_sale_shipment}</td>
                      <hr />
                    </tr>
                  ))}
                </tbody>
                <thead>
                  <tr>
                    <th>Grand Total</th>
                    <th>{totalSales}</th>
                    <th>{totalCogs}</th>
                    <th>{totalGPYearly}</th>
                    <th>{totalGPRatio}</th>
                    <th>{totalJobs}</th>
                    <th>{totalGPShipment}</th>
                    <th>{totalSalesShipment}</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </Wrapper>
      </div>
    </>
  );
};

export default RevenueData;
